import Text from '@amzn/meridian/text';
import {
  parseStringInOrder,
  extractMetricValue,
} from '../../../Dashboard/DashboardComponents/LighthouseMetrics/helper';
import { LighthouseMetrics } from '../../../Dashboard/DashboardComponents/LighthouseMetrics/types';
import { FormattedMessage } from 'react-intl';
import React from 'react';

interface DisplayBenchmarkProps {
  metricOption: string;
  metrics: LighthouseMetrics;
}
export const DisplayBenchmark: React.FC<DisplayBenchmarkProps> = ({
  metricOption,
  metrics,
}: DisplayBenchmarkProps): React.ReactElement => {
  const extractNetworkBenchmark = true;
  return (
    <>
      <i>
        <Text type='b200' color='secondary'>
          {metrics === undefined || metricOption === undefined ? (
            <Text>--</Text>
          ) : (metricOption as keyof LighthouseMetrics) !== 'ACHT' ? (
            parseStringInOrder(
              metricOption,
              metrics,
              extractNetworkBenchmark
            ) ? (
              <>
                {parseStringInOrder(
                  metricOption,
                  metrics,
                  extractNetworkBenchmark
                )}
              </>
            ) : (
              <Text>--</Text>
            )
          ) : extractMetricValue(
              metricOption,
              metrics,
              extractNetworkBenchmark
            ) !== null ? (
            <>
              {extractMetricValue(
                metricOption,
                metrics,
                extractNetworkBenchmark
              )}{' '}
              <FormattedMessage id='cs_perfportal_min' defaultMessage='min' />
            </>
          ) : (
            <Text>--</Text>
          )}
        </Text>
      </i>
    </>
  );
};
